export const BROKERAGE = {
  value: "BROKERAGE",
  key: "clients.client.categorisation.categoryForm.form.clientTypes.brokerage",
};

export const TPA = {
  value: "TPA",
  key: "clients.client.categorisation.categoryForm.form.clientTypes.tpa",
};

export const TPP = {
  value: "TPP",
  key: "clients.client.categorisation.categoryForm.form.clientTypes.tpp",
};

export const ASO = {
  value: "ASO",
  key: "clients.client.categorisation.categoryForm.form.clientTypes.aso",
};

export default [BROKERAGE, TPA, TPP, ASO];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/enums/categorisationClientTypeTypes.js